package example.shadcn_kotlin.ui.pages.docs.components.scroll_area

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.ScrollAreaDemo

@Page
@Composable
fun IndexPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/scroll-area/index.md", mapOf("title" to listOf("Scroll Area"), "description" to listOf("Augments native scroll functionality for custom, cross-browser styling."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/scroll-area"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/scroll-area#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h4
import shadcn.ui.components.ScrollArea
import shadcn.ui.components.Separator
import web.cssom.ClassName

val ScrollAreaDemo = FC<Props> {

    val tags = (1..50)
        .toList()
        .map {
            "v1.2.0-beta." + (50 - it)
        }

    ScrollArea {
        className = ClassName("h-72 w-48 rounded-md border")
        div {
            className = ClassName("p-4")
            h4 {
                className = ClassName("mb-4 text-sm font-medium leading-none")
                +"Tags"
            }
            tags.forEach {
                div {
                    className =ClassName("text-sm")
                    key = it
                    +it
                }
                Separator { className = ClassName("my-2") }
            }
        }
    }
}"""){ 
 ScrollAreaDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.ScrollArea
""", lang= "kotlin", highlight= "")
            CodeBlock("""ScrollArea {
    className = "h-[200px] w-[350px] rounded-md border p-4"
    + "Jokester began sneaking into the castle in the middle of the night and leaving "
    + "jokes all over the place: under the king's pillow, in his soup, even in the"
    + "royal toilet . The king was furious, but he couldn't seem to stop Jokester. And"
    + "then, one day, the people of the kingdom discovered that the jokes left by"
    + "Jokester were so funny that they couldn't help but laugh. And once they"
    + "started laughing, they couldn't stop."
}
""", lang= "kotlin", highlight= "")
        }
    }
}
